/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import get from 'lodash/get';

import { setAccountType } from '../../actions/accountTypeActions';

const useAccountType = () => {
    const dispatch = useDispatch();
    const accountData = useSelector((state) => state?.auth?.account?.account) || {};
    const facilityData = useSelector((state) => state?.timedEntry?.facility) || {};

    useEffect(() => {
        const isCommercialAccount = accountData?.is_commercial_account || false;
        const facilityId = facilityData?.facility_id;

        if (isCommercialAccount && facilityId) {
            const availablePermit = get(accountData, ['special_use_permits', facilityId]);

            if (
                availablePermit &&
                !availablePermit.is_suspended &&
                moment(availablePermit.expiration).isAfter(moment())
            ) {
                dispatch(setAccountType('COMM'));
            } else {
                dispatch(setAccountType('FIT'));
            }
        }
    }, [accountData, facilityData, dispatch]);

    return null;
};

export default useAccountType;
